import React, { useState } from "react";
import { useLocation } from "wouter";
import { uploadCuMassive } from "../services/api";
import UploadForm from "./upload_form";

// import { useNavigate } from 'wouter';

export default function CardCaricaCu(props) {
  // const navigate = useNavigate()

  const [location, setLocation] = useLocation();

  function buildYearChunk({ startYear, count }) {
    return Array.from({ length: count }, (_, i) => {
      const y = startYear - i;
      return { label: String(y), value: String(y) };
    });
  }

  const NOW_YEAR = new Date().getFullYear();
  const CHUNK = 15;

  const [yearOptions, setYearOptions] = useState(() =>
    buildYearChunk({ startYear: NOW_YEAR, count: CHUNK })
  );
  const minLoadedYear = Number(yearOptions[yearOptions.length - 1]?.value || NOW_YEAR);

  const loadMoreYears = () => {
    const nextStart = minLoadedYear - 1;
    const more = buildYearChunk({ startYear: nextStart, count: CHUNK });

    setYearOptions((prev) => {
      const existing = new Set(prev.map((o) => o.value));
      const filtered = more.filter((o) => !existing.has(o.value));
      return [...prev, ...filtered];
    });
  };

  return (
    <div className = "overflow-hidden rounded-lg bg-white mb-10" >
      <div className="p-2">
        <h2 className="text-base font-medium text-gray-900" id="recent-hires-title">
          Carica Certificazioni Uniche Massive
        </h2>
        <div className="mt-6 flow-root">
          <UploadForm
            enableUpload={true}
            message={{
              success: ({ anno, year, reference_year }) => {
                const y = year ?? anno ?? reference_year;

                return (
                  <button
                    type="button"
                    className="text-amber-700 underline font-semibold"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      const base = (location || "").split("?")[0];
                      const qs = new URLSearchParams();
                      if (y) qs.set("year", String(y));
                      qs.set("focus", "1");

                      setLocation(`${base}?${qs.toString()}`);

                      Promise.resolve().then(() => props.setClose(false));
                    }}
                  >
                    Per confermare i documenti clicca qui
                  </button>
                );
              },
            }}
            fields={
              [
                { name: 'year', label: 'Anno', type: 'select', options: yearOptions, onScrollEnd: loadMoreYears },
                { name: 'reference_year', label: 'Anno di Riferimento', type: 'select', options: yearOptions, disabled: true },
                {
                  name: 'notify_employee', label: 'Notifica i dipendenti via email', defaultChecked: true, type: 'checkbox', options: [
                    { label: 'Si', value: true }
                  ]
                },
                { type: 'hidden', name: 'anagrafica_create_missing', value: 'true' },
                { type: 'hidden', name: 'typology', value: 'cu' }
              ]
            }
            formType="CUMassive"
            submitLabel="Carica"
            submitAction={uploadCuMassive}
          />
        </div>
      </div>
    </div>
  )

}